(function () {
    "use strict";

    app.value("settings", {
        minimumNumberOfLines: 2,
        maximumNumberOfLines: 5,
        lines: [
            { multiLineDiscount: 0 },
            { multiLineDiscount: 10 },
            { multiLineDiscount: 10 },
            { multiLineDiscount: 20 },
            { multiLineDiscount: 20 }
        ],
        plans: [
            {
                name: "5GB",
                data: 5,
                price: 30,
                autoPayDiscount: 0,
                unlimitedTalk: false,
                inclusions: [
                    "<strong>Data</strong> - 5GB with 5G<sup>1</sup>",
                    "<strong>Hotspot data</strong> - from plan allowance",
                ]
            },
            {
                name: "15GB",
                data: 15,
                price: 40,
                autoPayDiscount: 0,
                inclusions: [
                    "<strong>Data</strong> - 15GB with 5G<sup>1</sup>",
                    "<strong>Hotspot data</strong> - from plan allowance",
                    "<strong>Mexico & Canada<sup>2</sup></strong><br><small>5G avail. in U.S. only</small>",
                ]
            },
            {
                name: "Unlimited MAX℠",
                data: -1,
                price: 65,
                autoPayDiscount: 10,
                autoPayPromotionPricing: false,
                inclusions: [
                    "<strong>Data</strong> - Unlimited with 5G<sup>1</sup>",
                    "<strong>Hotspot data<sup>3</sup></strong> - 25GB",
                    "<strong>Mexico & Canada<sup>2</sup></strong><br><small>Limit: 25GB in Canada, 5G avail. in U.S. only.</small>",
                    "<strong>Cloud Storage<sup>4</sup></strong> - 100GB",
                    "<strong>HD Streaming</strong> - available",
                ]
            },
            {
                name: "Unlimited MAX Plus℠",
                data: -1,
                price: 75,
                autoPayDiscount: 10,
                autoPayPromotionPricing: false,
                inclusions: [
                    "<strong>Data</strong> - Unlimited high-speed with 5G<sup>1</sup>",
                    "<strong>Hotspot data<sup>3</sup></strong> - 35GB",
                    "<strong>Mexico & Canada<sup>2</sup></strong><br><small>Limit: 25GB in Canada, 5G avail. in U.S. only.</small>",
                    "<strong>Cloud Storage<sup>4</sup></strong> - 100GB",
                    "<strong>HD Streaming</strong> - available",
                    "<strong>International calling from the U.S.5<sup>5</sup></strong> - 500 min. to 30+ countries",
                ]
            },  
        ],
        defaultPlan: "Unlimited MAX℠"
    });

})();